import { isPlatformServer } from '@angular/common';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  constructor() { }

  environments: any = environment;

  /**
   * Method to validate image files.
   * @returns boolean of true if image file is valid else false.
   */
  validateImageOrVideoFile(file: any, fileSize: number, sizeString: string, isImageFile: boolean): { message: string, isValid: boolean } {
    if (isImageFile) {
      if ((file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' || file.type === 'image/webp') && file.size <= fileSize) {
        return { message: '', isValid: true };
      }
      else if ((file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' || file.type === 'image/webp') && file.size > fileSize) {
        return { message: `Uploaded file is greater than ${sizeString}.`, isValid: false };
      }
      else if (file.type !== 'image/jpeg' ||
        file.type !== 'image/png' ||
        file.type !== 'image/jpg' ||
        file.type !== 'image/gif' || file.type !== 'image/webp' || file.type === 'image/gif') {
        return { message: `Unsupported image format.`, isValid: false };
      }
    }
    else {
      if (file.type.indexOf('video') > -1 && file.size <= fileSize) {
        return { message: '', isValid: true };
      }
      else if (file.type.indexOf('video') > -1 && file.size > fileSize) {
        return { message: `Uploaded file is greater than ${sizeString}.`, isValid: false };
      }
      else if (file.type.indexOf('video') === -1) {
        return { message: `Unsupported video format.`, isValid: false };
      }
    }
  }

  validatFileSize(file: any, fileSize: number, sizeString: string) {
    if (file.size <= fileSize) {
      return { message: '', isValid: true };
    } else {
      return { message: `Uploaded file is greater than ${sizeString}.`, isValid: false };
    }
  }

  /**
   * Method to return image based on image name and module name.
   * @param imageName Name of the image.
   * @param moduleName Name of the module.
   * @returns Image URL.
   */
  getImage(imageName: string, moduleName: string, width?: number, height?: number, cover?: boolean, calledFrom?: string): string {


    let data: any = calledFrom == 'dataTable' ? {
      "bucket": environment.imageBucket,
      "key": `${moduleName}/${imageName}`
    } : {
      "bucket": environment.imageBucket,
      "key": `${moduleName}/${imageName}`,
      "edits": {
        "resize": {
          "width": width,
          "height": height,
          "fit": "inside"
        }
      }
    };

    let dimension = '600x600';
    if (width && height) {
      dimension = `${width}x${height}`;
    }
    let fitIn = 'fit-in/';
    if (cover === true) {
      fitIn = '';
    }
    if (imageName && imageName !== '' && moduleName && moduleName !== ''
      && imageName !== `../../../../../../assets/images/blank.png` && !imageName.includes('base64')) {
      //return `${environment.imageBaseUrl}${btoa(JSON.stringify(data))}`;
      // return `${environment.imageBaseUrl}${moduleName}//${fitIn}${dimension}/${imageName}`;
      return this.environments.isDevServer ? `${environment.imageBaseUrl}${this.encodingData(data)}` : `${environment.imageBaseUrl}${moduleName}//${fitIn}${dimension}/${imageName}`;
    }
    else if (imageName && imageName !== '' && moduleName && moduleName !== ''
      && imageName !== `../../../../../../assets/images/blank.png` && imageName.includes('base64')) {
      return imageName;
    }
    return '';
  }

  getLazyImage(imageName: string, moduleName: string, isDefault: boolean, size: string, pattern?: string, isBlur?: boolean, timestamp?: string): string {

    let newName: string = '';
    let extension: string = '';
    if (timestamp) {
      newName = imageName.split('.')[0];
      extension = imageName.split('.')[1];
      imageName = `${newName}_${timestamp}.${extension}`;

      if (imageName && imageName !== '' && moduleName && moduleName !== '' && typeof imageName === 'string'
        && imageName !== `../../../../../../assets/images/blank.png`
        && imageName !== `../../../../../assets/images/image.svg`
        && !imageName.includes('base64')) {

        return `${environment.imageBaseUrl}${moduleName}/${imageName}`;
      }
    }
    return '';
  }
  encodingData(data: any) {
    const text = JSON.stringify(data);
    const encoder = new TextEncoder();
    const dataUtf8 = encoder.encode(text);
    const encodedData = btoa(String.fromCharCode.apply(null, dataUtf8));
    return encodedData;
  }


  getImageData(imageName: string, moduleName: string, imageHeight:number, imageWidth:number, name?: string, extension?: any): string {
    let imageUrl;
    imageUrl = `${moduleName}/fit-in/${imageHeight}x${imageWidth}/${imageName}`;
    if (imageName && imageName !== '' && moduleName && moduleName !== '' && imageName !== `../../../../../../assets/images/blank.png` && !imageName.includes('base64')) {
      return `${environment.imageBaseUrl}${imageUrl}`
    }
  }

  getAssetsImage(imageName:string, moduleName: string){
    let imageUrl = `${moduleName}/${imageName}`;
    return `${environment.imageBaseUrl}${imageUrl}`
  }
}
